import { CF } from '@dadohr/shared/versions';
import { useFirebaseFunction } from '../../../../../../services/firebaseFunctions';
import { ONE_MINUTE } from '../../../../../../services/time';

export const useSharepointSites = (orgId: string) => {
  return useFirebaseFunction<
    {
      id: string;
      displayName: string;
      webUrl: string;
    }[]
  >(CF.microsoft.sharepoint.getSites, { orgId }, [orgId], ONE_MINUTE * 5);
};

export const useSiteDrives = (orgId: string, siteId: string) => {
  return useFirebaseFunction<
    {
      id: string;
      name: string;
      webUrl: string;
    }[]
  >(
    CF.microsoft.sharepoint.getSiteDrives,
    { orgId, siteId },
    [orgId],
    ONE_MINUTE * 5
  );
};
